import { roundNumber } from '@common/methods/roundNumber/roundNumber';
import { config } from '../../config';

class chartClass {
	updateProfitHistory(value, lastData = [], limit = config.chartLimit) {
		lastData = [
			...lastData,
			{
				// color: value > 0 ? '#1dbb2f' : '#f1001c',
				y: roundNumber(
					(lastData.length ? lastData[lastData.length - 1].y : 0) + value,
				),
				x: lastData.length ? lastData[lastData.length - 1].x + 1 : 1,
				// published_at: new Date().getTime(),
			},
		];
		if (lastData.length > limit) {
			lastData.shift();
		}
		return lastData;
	}
}

const chartService = new chartClass();

export default chartService;
